module.exports = __webpack_public_path__ + "img/maltose.b0f0c1a1.png";